import React, { Component } from "react";
import menuMaster from "../../menu";
import MenuHeading from "../../components/Menu/MenuHeading";
import MenuLink from "../../components/Menu/MenuLink";
import MenuEnd from "../../components/Menu/MenuEnd";
import SiteMapCol from "../../components/Menu/SiteMapCol";

class SiteMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      section: []
    };

    for (var i = 0; i < menuMaster.length; i++) {
      this.state.section.push(menuMaster[i].section);
    }
  }

  render() {
    var section = this.state.section.map(function(item, index) {
      return <SiteMapCol key={index} section={item} />;
    });

    return (
      <div style={{ fontSize: "80%" }}>
        {section}
        {/* 
        <div
          style={{
            width: 32,
            height: 32,
            display: "block",
            position: "relative"
          }}
        >
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/aBrcvDBMgbo?rel=0&amp;autoplay=1&mute=1"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <div
            style={{
              backgroundColor: "rgb(15, 17, 26)",
              display: "block",
              position: "absolute",
              top: 0,
              left: 0,
              width: 32,
              height: 32
            }}
          ></div>
        </div> */}
      </div>
    );
  }
}

export default SiteMap;



// WEBPACK FOOTER //
// ./src/components/Menu/SiteMap.js